// 2023-02-02 -> 1 yrs 5 m
export const convertTotalPeriodFromStartDate = (
  startDate: string,
  endDate?: string,
) => {
  const currentDate = endDate ? new Date(endDate) : new Date();
  const startDateInDate = new Date(startDate);
  const totalMonths =
    (currentDate.getFullYear() - startDateInDate.getFullYear()) * 12 +
    (currentDate.getMonth() - startDateInDate.getMonth());
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  if (years === 0) {
    return `${months} m`;
  }

  if (months === 0) {
    return `${years} yrs`;
  }

  return `${years} yrs ${months} m`;
};

// convert "2023-02-02" to Feb 2023
export const convertDateToMonthYear = (date: string) => {
  const dateInDate = new Date(date);
  const month = dateInDate.toLocaleString("default", { month: "short" });
  const year = dateInDate.getFullYear();
  return `${month} ${year}`;
};

export const convertStartAndEndDateToYearsAndMonth = (
  startDate: string,
  endDate?: string,
) => {
  const returnValue = `${convertDateToMonthYear(startDate)}
                      ${` - ${endDate ? convertDateToMonthYear(endDate) : "Present"} `}
                      (${convertTotalPeriodFromStartDate(startDate, endDate)})`;
  return returnValue;
};
